
export const StyleTattoData = (t) => {
  return [
    {
      id: "fineline",
      text: `${t("styleData.styleFineline")}`,
      value: "Fineline",
    },
    {
      id: "geometrio",
      text: `${t("styleData.styleGeometric")}`,
      value: "Geométrico",
    },
    {
      id: "micro-realista",
      text: `${t("styleData.styleMicroRealistic")}`,
      value: "Micro Realista",
    },
    {
      id: "realismo",
      text: `${t("styleData.styleRealism")}`,
      value: "Realismo",
    },
    {
      id: "tradicional",
      text: `${t("styleData.styleTraditional")}`,
      value: "Tradicional",
    },
    {
      id: "floral",
      text: `${t("styleData.styleFloral")}`,
      value: "Floral",
    },
    {
      id: "anime",
      text: `${t("styleData.styleAnime")}`,
      value: "Anime",
    },
    {
      id: "prefiero-asesorarme",
      text: `${t("styleData.stylePreferToConsult")}`,
      value: "Prefiero asesorarme",
    },
  ];
};
